// The enum values here should be matched to the exact string
// returned by the server otherwise parsing the response won't
// be able to convert it to the correct enum.
export enum SharingLinkProviderType {
    OneDrivePro = 'OneDrivePro',
}

export enum SharingLinkType {
    None = 'None',
    View = 'View',
    Edit = 'Edit',
    AnonymousView = 'AnonymousView',
    AnonymousEdit = 'AnonymousEdit',
    OrganizationView = 'OrganizationView',
    OrganizationEdit = 'OrganizationEdit',
}

export interface SharingLink {
    type: SharingLinkType;
    url: string;
}

export interface SharingLinkInfoResponse {
    providerType: SharingLinkProviderType;
    name: string;
    previewUrl: string;
    linkType: SharingLinkType;
    sharingLinks: SharingLink[];
}

export interface OneDriveProSharingLinkInfoResponse extends SharingLinkInfoResponse {
    providerType: SharingLinkProviderType.OneDrivePro;
    canonicalUrl: string;
    expirationTime: string;
    accessRequestMode: boolean;
    canCreateAnonymousEditLink: boolean;
    canCreateAnonymousViewLink: boolean;
    canCreateOrganizationEditLink: boolean;
    canCreateOrganizationViewLink: boolean;
    canShareExternally: boolean;
    canShareInternally: boolean;
}
